// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chat-heart"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2.5 3H21.5V17H6.5L2.5 20.5L2.5 3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M8.64143 10.091C7.76275 9.21231 7.76275 7.78769 8.64143 6.90901C9.52011 6.03033 10.9447 6.03033 11.8234 6.90901L12.0002 7.08579L12.177 6.90901C13.0556 6.03033 14.4803 6.03033 15.3589 6.90901C16.2376 7.78769 16.2376 9.21231 15.3589 10.091L12.0002 13.4497L8.64143 10.091Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.5 3H21.5V17H6.5L2.5 20.5L2.5 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.64143 10.091C7.76275 9.21231 7.76275 7.78769 8.64143 6.90901C9.52011 6.03033 10.9447 6.03033 11.8234 6.90901L12.0002 7.08579L12.177 6.90901C13.0556 6.03033 14.4803 6.03033 15.3589 6.90901C16.2376 7.78769 16.2376 9.21231 15.3589 10.091L12.0002 13.4497L8.64143 10.091Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}}]}]};

const ChatHeartIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-heart',
    ref,
    icon: element,
  },
));

ChatHeartIcon.displayName = 'ChatHeartIcon';

export default ChatHeartIcon;
